/* 团购 share-to-unlock: the product page's group panel (blocks/ex-group.liquid).
 *
 *   no ?g=            nothing to do: the server-rendered P1/P2 stands
 *   ?g=CODE           skeleton → GET /apps/join/group/status?g=CODE (3s budget)
 *     open + this product  → P3, write cart attribute group=CODE, hide express checkout
 *     filled / expired / unknown / another product → that P4 line under P1/P2
 *     error or timeout → P1/P2 + "We couldn't check this group"; NO attribute written
 *   a different code already on the cart → the latest link wins, "Switched to this group"
 *
 * The amount is this viewer's: floor(pct of the price) minus their member discount, in
 * cents (data attributes from Liquid), the settle's own rule. No ticking countdown. */
(function () {
  var root = document.querySelector("[data-ex-group]");
  if (!root) return;
  var code = (new URLSearchParams(location.search).get("g") || "").trim().toUpperCase();
  if (!/^[23456789ABCDEFGHJKMNPQRSTUVWXYZ]{8}$/.test(code)) return;

  var part = function (n) { return root.querySelector('[data-part="' + n + '"]'); };
  var skel = root.querySelector(".ex-group-skel");
  var copy = JSON.parse(root.querySelector("template[data-copy]").innerHTML);
  var fill = function (t, v) { return t.replace(/\{(\w+)\}/g, function (_, k) { return v[k]; }); };
  var money = function (c) { return "S$" + (c / 100).toFixed(2); };

  part("base").hidden = true;
  skel.hidden = false;
  var done = function () {
    skel.hidden = true;
    root.classList.remove("is-checking");
    var t = root.querySelector("[data-checking-text]");
    if (t) t.textContent = "";
  };
  var fallback = function (which) { done(); part("base").hidden = false; part(which).hidden = false; };

  var ctl = window.AbortController ? new AbortController() : null;
  var timer = setTimeout(function () { if (ctl) ctl.abort(); }, 3000);
  fetch("/apps/join/group/status?g=" + encodeURIComponent(code), { credentials: "same-origin", signal: ctl && ctl.signal })
    .then(function (r) { return r.json(); })
    .then(function (s) {
      clearTimeout(timer);
      if (s.state === "error") return fallback("error");
      if (s.state === "open" && s.product_gid === "gid://shopify/Product/" + root.getAttribute("data-product-id")) return open(s);
      // A group for another product reads as "couldn't find" here: it is not this page's.
      if (s.state === "expired" && s.opened_at && s.closes_at) {
        // The expired group's own window, not today's default.
        var h = Math.round((new Date(s.closes_at).getTime() - new Date(s.opened_at).getTime()) / 3600000);
        root.querySelectorAll("[data-hours]").forEach(function (n) { n.textContent = String(h); });
      }
      fallback(s.state === "filled" || s.state === "expired" ? s.state : "unknown");
      forget();
    })
    .catch(function () { clearTimeout(timer); fallback("error"); });

  function open(s) {
    var o = part("open");
    var slots = o.querySelector("[data-slots]");
    for (var i = 0; i < s.size; i++) {
      var d = document.createElement("span");
      d.className = "ex-group-slot" + (i < s.bought ? " is-in" : "");
      slots.appendChild(d);
    }
    slots.setAttribute("aria-label", fill(copy.slots, { n: s.bought, size: s.size }));
    o.querySelector("[data-bought]").textContent = fill(copy.bought, { n: s.bought, size: s.size });
    var closes = new Date(s.closes_at);
    var loc = root.getAttribute("data-locale");
    var when = closes.toLocaleDateString(loc, { weekday: "short", day: "numeric", month: "short", timeZone: "Asia/Singapore" }) +
      ", " + closes.toLocaleTimeString(loc, { hour: "numeric", minute: "2-digit", timeZone: "Asia/Singapore" });
    o.querySelector("[data-closes]").textContent = fill(copy.closes, { when: when });
    var ms = Math.max(0, closes.getTime() - Date.now());
    var left = o.querySelector("[data-left]");
    if (ms < 3600000) {
      left.textContent = fill(copy.leftMin, { m: Math.ceil(ms / 60000) });
      left.className = "is-final";
    } else {
      left.textContent = fill(copy.left, { h: Math.floor(ms / 3600000) });
    }
    var price = Number(root.getAttribute("data-price-cents"));
    var off = Number(root.getAttribute("data-off-cents"));
    var back = Math.max(0, Math.floor(price * Number(s.pct) / 100) - off);
    o.querySelector("[data-back]").textContent = back > 0
      ? fill(copy.back, { size: s.size, amount: money(back) })
      : fill(copy.noBack, { pct: Number(s.pct) });
    done();
    o.hidden = false;
    remember(o);
  }

  // The cart attribute is what the order carries to the ingest (note_attributes). Express
  // checkout skips the cart and would drop it, so it is hidden on every page while set
  // (ex-header does it on later page loads; this does it now).
  function remember(o) {
    var prev = root.getAttribute("data-cart-group");
    hideExpress();
    if (prev === code) return;
    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ attributes: { group: code } }),
    }).then(function (r) {
      if (!r.ok) return; // landing_site ?g= stays the ingest's fallback
      root.setAttribute("data-cart-group", code);
      if (prev) o.querySelector("[data-switched]").hidden = false;
    }).catch(function () { /* landing_site ?g= is the ingest's fallback */ });
  }

  // The selectors live once, in ex.css (html.ex-group-noexpress); ex-header sets the same
  // class on later page loads.
  // A closed or unknown group: clear THIS code from the cart, so express checkout comes back
  // and a later order is not stamped with a dead group (adversarial review).
  function forget() {
    if (root.getAttribute("data-cart-group") !== code) return;
    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ attributes: { group: "" } }),
    }).then(function (r) {
      if (!r.ok) return;
      root.setAttribute("data-cart-group", "");
      document.documentElement.classList.remove("ex-group-noexpress");
    }).catch(function () {});
  }

  function hideExpress() {
    document.documentElement.classList.add("ex-group-noexpress");
  }
})();
